// A2-537 (Antigravity follow-up, 2026-10-25): a client filing CZ monthly and
// GB quarterly runs a quarterly calc, and that calc still builds a CZ form
// for the whole quarter with no word that it is the wrong period for CZ.
// Step 2 now says those registrations file on their own periods; this says
// it on the form itself. Advisory, not a block: a LOCAL return's frequency
// can have genuine stub periods (engine/filing_cadence_guard.py), so it only
// speaks when the period is a WHOLE statutory period of a different length
// than the client's saved frequency for this country. Never on Italy's
// monthly bundle, which splits a quarter into its three monthly returns.
import React from "react";
import { useTranslation } from "react-i18next";
import { classifyStatutoryPeriod } from "../../lib/filingPeriods";
import { countryName } from "../../lib/countries";

export const PeriodCadenceNote = ({ payload }) => {
  const { t } = useTranslation();
  const saved = payload?.client_cadence;
  const shape = classifyStatutoryPeriod(payload?.period_start, payload?.period_end);
  if (Array.isArray(payload?.modules) || !saved || !shape || shape === saved) return null;
  const word = (c) => t(`ui.calculate.period_card.cadence_${c.toLowerCase()}`, { defaultValue: c.toLowerCase().replace("_", "-") });
  const country = countryName(payload.country);
  return (
    <div data-testid="period-cadence-note" role="status"
      className="text-sm rounded-lg p-3 mb-4 border text-amber-900 dark:text-amber-100 bg-amber-50 dark:bg-amber-950/40 border-amber-400 dark:border-amber-700">
      {t("ui.country_return.period_cadence_note", {
        country, saved: word(saved), shape: word(shape),
        defaultValue: `This client files ${country} returns ${word(saved)}, and this calculation covers a ${word(shape)} period. Do not file this form; file the ${country} return from a calculation for each ${word(saved)} period.`,
      })}
    </div>
  );
};
